import React from 'react';
import { Box, Container, Typography, Grid, Card, CardMedia } from '@mui/material';
import {siteConfig} from "../../config/siteConfig";

const BrandShowcase = ({ brands }) => {
    return (
        <Box sx={{ py: 10, bgcolor: 'white' }}>
            <Container maxWidth="lg">
                {/* Title Section */}
                <Box sx={{ textAlign: 'center', mb: 8 }}>
                    <Typography
                        variant="h3"
                        sx={{
                            fontWeight: 'bold',
                            mb: 2,
                            color: siteConfig.colors.secondary,
                            '& span': {
                                color: siteConfig.colors.primary
                            }
                        }}
                    >
                        Unterstützte <span>Marken</span>
                    </Typography>

                    {/* Accent Line */}
                    <Box sx={{
                        width: '80px',
                        height: '4px',
                        bgcolor: siteConfig.colors.primary,
                        margin: '0 auto',
                        mb: 3
                    }} />

                    <Typography
                        variant="h6"
                        sx={{
                            color: siteConfig.colors.text,
                            fontWeight: 400
                        }}
                    >
                        Wir bieten Chiptuning für alle führenden Automobilhersteller
                    </Typography>
                </Box>

                {/* Brand Grid */}
                <Grid container spacing={3}>
                    {brands.map((brand, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <Card
                                sx={{
                                    position: 'relative',
                                    height: 280,
                                    borderRadius: 3,
                                    overflow: 'hidden',
                                    cursor: 'pointer',
                                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                    '&:hover': {
                                        transform: 'translateY(-8px)',
                                        boxShadow: '0 20px 40px rgba(0,0,0,0.2)',
                                        '& .brand-overlay': {
                                            bgcolor: 'rgba(0,0,0,0.3)'
                                        }
                                    }
                                }}
                            >
                                {/* Background Image */}
                                <CardMedia
                                    component="img"
                                    image={brand.image}
                                    alt={brand.name}
                                    sx={{
                                        height: '100%',
                                        width: '100%',
                                        objectFit: 'cover',
                                    }}
                                />

                                {/* Dark Overlay */}
                                <Box
                                    className="brand-overlay"
                                    sx={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        bgcolor: 'rgba(0,0,0,0.4)',
                                        transition: 'background-color 0.3s ease',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Typography
                                        variant="h4"
                                        sx={{
                                            color: 'white',
                                            fontWeight: 'bold',
                                            textShadow: '2px 2px 8px rgba(0,0,0,0.5)',
                                            letterSpacing: '1px'
                                        }}
                                    >
                                        {brand.name}
                                    </Typography>
                                </Box>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default BrandShowcase;